/** Lifecycle vocabulary of versioned content (#4060): states, their legal transitions, event actions and origins. */

export const CONTENT_VERSION_STATES = [
  'draft',
  'in_review',
  'approved',
  'published',
  'superseded',
  'retired',
  'discarded',
] as const
export type ContentVersionState = (typeof CONTENT_VERSION_STATES)[number]

export const CONTENT_EVENT_ACTIONS = [
  'draft_saved',
  'draft_discarded',
  'published',
  'retired',
] as const
export type ContentEventAction = (typeof CONTENT_EVENT_ACTIONS)[number]

export const CONTENT_VERSION_ORIGINS = ['editor', 'restore', 'seed', 'adopt', 'package'] as const
export type ContentVersionOrigin = (typeof CONTENT_VERSION_ORIGINS)[number]

/** Every state lists the states it may move to; the terminal ones list none. Frozen: nothing edits it at runtime. */
export const CONTENT_STATE_TRANSITIONS: Readonly<
  Record<ContentVersionState, readonly ContentVersionState[]>
> = Object.freeze({
  draft: Object.freeze(['in_review', 'published', 'discarded'] as const),
  in_review: Object.freeze(['approved', 'draft'] as const),
  approved: Object.freeze(['published'] as const),
  published: Object.freeze(['superseded', 'retired'] as const),
  superseded: Object.freeze([] as const),
  retired: Object.freeze([] as const),
  discarded: Object.freeze([] as const),
})

/** False for an unknown `from` too (a string read from the database), instead of throwing. */
export function canTransition(from: ContentVersionState, to: ContentVersionState): boolean {
  if (!Object.hasOwn(CONTENT_STATE_TRANSITIONS, from)) return false
  return CONTENT_STATE_TRANSITIONS[from].includes(to)
}
